/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React from "react";
import SearchInput from "./Searchinput"; // Adjust path as per your project

interface PageHeaderWithActionProps {
  title: string;
  count?: number;
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  buttonText?: string;
  buttonIcon?: string;
  onButtonClick?: () => void;
}

const Addbutton: React.FC<PageHeaderWithActionProps> = ({
  title,
  count,
  searchValue,
  onSearchChange,
  onSearchKeyUp,
  buttonText = "Add",
  buttonIcon = "add_circle",
  onButtonClick,
}) => {
  return (
    <>
      <div className="title mb-3">
        <h3 className="mb-0">
          {title}
          {typeof count === "number" ? ` (${count})` : ""}
        </h3>
      </div>

      <div className="col-12 title-btm">
        {/* Use your existing reusable SearchInput */}
        <SearchInput
          value={searchValue}
          onChange={onSearchChange}
          onKeyUp={onSearchKeyUp}
        />

        <div className="d-flex justify-content-end title-btm-btn-sec">
          <button
            className="btn btn-primary btn-ico rounded-5 ms-auto me-2"
            onClick={onButtonClick}
          >
            <i className="material-symbols-outlined">{buttonIcon}</i>{" "}
            {buttonText}
          </button>
        </div>
      </div>
    </>
  );
};

export default Addbutton;
